import { UtmTags } from './models/utm-tags';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ClearUtmTags, UpdateUtmTags } from './analytics.actions';

export class AnalyticsStateModel {
  utmTags: UtmTags;
}

@State<AnalyticsStateModel>({
  name: 'analytics',
  defaults: {
    utmTags: undefined
  }
})
@Injectable()
export class AnalyticsState {
  @Selector()
  static selectUtmTags(state: AnalyticsStateModel): UtmTags {
    return state.utmTags;
  }

  @Action(UpdateUtmTags)
  private updateUtmTags(ctx: StateContext<AnalyticsStateModel>, action: UpdateUtmTags) {
    return ctx.patchState({ utmTags: action.payload });
  }

  @Action(ClearUtmTags)
  private clearUtmTags({ patchState }: StateContext<AnalyticsStateModel>) {
    return patchState({ utmTags: null });
  }
}
